// actions
import {
  GOOGLE_SET_MAP,
  GOOGLE_SET_ZOOM,
  GOOGLE_SET_LANGUAGE,
  GOOGLE_SET_REGION,
  GOOGLE_SET_GEOLOCATION,
  GOOGLE_SET_ENTRYPOINT,
} from './actions';

const GoogleMap = (state = {
  mapLoaded: false,
  zoom: 0,
  language: '',
  region: '',
  geolocation: false,
  entryPoint: false,
}, action) => {
  switch (action.type) {
    case GOOGLE_SET_MAP:
      return {
        ...state,
        mapLoaded: action.mapLoaded,
      };
    case GOOGLE_SET_ZOOM:
      return {
        ...state,
        zoom: action.zoom,
      };
    case GOOGLE_SET_LANGUAGE:
      return {
        ...state,
        language: action.language,
      };
    case GOOGLE_SET_REGION:
      return {
        ...state,
        region: action.region,
      };
    case GOOGLE_SET_GEOLOCATION:
      return {
        ...state,
        geolocation: action.geolocation,
      };
    case GOOGLE_SET_ENTRYPOINT:
      return {
        ...state,
        entryPoint: action.entryPoint,
      };
    default:
      return state;
  }
};

export default GoogleMap;
